var loadProductSnap = function() {
  var snapProduct = [];
  // Look for an element with class 'product-snap'
  var productSnapSection = document.querySelector('.product-snap');
  if (productSnapSection === null) {
    return;
  }
  // Read product ID from data attribute
  var productId = productSnapSection.dataset.productId;
  if (snapProductList[productId]) {
    snapProduct = snapProductList[productId];
    if (snapProduct.length > 0) {
      var htmlImg = '';
      var htmlSnap = '';
      snapProduct.forEach((element, index) => {
        htmlImg =
          htmlImg +
          `<li class="product product-snap-product"><img id="snap-item-image-${index}" class="product__img product-snap-product-img" src="${element}"></li>`;
      });
      htmlSnap = `<p class="product-snap-title">SNAP</p>
      <p class="product-snap-sub-title">この商品の着用写真はこちら</p>
      <ul class="product product-snap-list">
        ${htmlImg}
      </ul>`;
      document.getElementById('snap-product').innerHTML = htmlSnap;
    }
  }
};
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === 'product-snap') {
    loadProductSnap();
  }
});
loadProductSnap();